/**
 * Dev Mail - List Command
 * List all temp email accounts
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { ConfigService } from '../../../services/config.service.js';
import { TempMailApiService } from '../../../services/temp-mail.service.js';

interface ListOptions {
    json?: boolean;
}

async function handleList(options: ListOptions): Promise<void> {
    const config = await new ConfigService().load();
    if (!config) {
        console.error('❌ Not initialized. Run "jai1 auth" first.');
        process.exit(1);
    }

    const api = new TempMailApiService(config);
    const result = await api.listAccounts();

    if (!result.success) {
        if (options.json) {
            console.log(JSON.stringify({ success: false, error: result.error }));
        } else {
            console.error(`❌ ${result.error}`);
        }
        process.exit(1);
    }

    const accounts = result.data ?? [];

    if (options.json) {
        console.log(JSON.stringify({ success: true, data: accounts }));
        return;
    }

    if (!accounts.length) {
        console.log(chalk.dim('Chưa có temp email nào. Tạo mới bằng: j dev mail create'));
        return;
    }

    console.log(chalk.bold.cyan(`📬 Temp Email Accounts (${accounts.length}/20)\n`));
    console.log(
        chalk.bold(`  ${'#'.padEnd(4)} ${'Address'.padEnd(40)} Created`)
    );
    console.log('  ' + '─'.repeat(70));

    accounts.forEach((acc, i) => {
        const idx = chalk.dim(String(i + 1).padEnd(4));
        const addr = chalk.cyan(acc.address.padEnd(40));
        const date = chalk.dim(new Date(acc.created_at).toLocaleDateString('vi-VN'));
        console.log(`  ${idx} ${addr} ${date}`);
    });

    console.log();
}

export function createMailListCommand(): Command {
    return new Command('list')
        .description('Liệt kê tất cả temp email accounts')
        .option('-j, --json', 'Output dạng JSON')
        .addHelpText('after', `
Examples:
  $ j dev mail list
  $ j dev mail list -j
`)
        .action(async (options: ListOptions) => {
            await handleList(options);
        });
}
